import { Card, Container, Row, Col, Button, Badge } from "react-bootstrap";
import { FaEdit, FaCamera, FaMapMarkerAlt } from "react-icons/fa";
import defaultAvatar from "../assets/images/user.png";
import Layout from "../layout/Layout";
import { useProfileDetailsQuery } from "../redux/services/profileService";
import { useTranslation } from "react-i18next";

const ViewProfile = () => {
  const { t } = useTranslation();
  const { data: profileData } = useProfileDetailsQuery();

  // Format dates
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Layout>
      <Container className="py-4 px-4 px-md-5">
        <h3 className="mb-4 fw-bold">{t("my profile")}</h3>

        {/* Profile Header */}
        <Card className="border-0  mb-4">
          <Card.Body className="d-flex flex-column flex-md-row align-items-center p-4">
            <div className="me-md-4 mb-3 mb-md-0 position-relative">
              <img
                src={profileData?.photo || defaultAvatar}
                alt="Profile"
                className="rounded-circle"
                width="100"
                height="100"
                style={{ objectFit: "cover" }}
              />
              <div
                className="position-absolute bottom-2 end-6 bg-primary rounded-circle d-flex align-items-center justify-content-center border border-white"
                style={{
                  width: "28px",
                  height: "28px",
                  transform: "translate(5px, -5px)",
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }}
                title="Change profile picture"
              >
                <FaCamera color="white" size={12} />
              </div>
            </div>
            <div>
              <h4 className="fw-bold mb-1">{profileData?.name}</h4>
              <div className="mb-2">
                <Badge bg="primary" className="text-uppercase px-2 py-1">
                  {profileData?.role}
                </Badge>
              </div>
              <div className="d-flex align-items-center text-muted">
                <FaMapMarkerAlt className="me-1 text-danger" />
                <p className="mb-0">{profileData?.address}</p>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* Personal Information */}
        <Card className="border-0  mb-4">
          <Card.Body className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold mb-0">{t("personal information")}</h5>
              <Button
                variant="light"
                className="d-flex align-items-center bg-primary text-white"
              >
                <FaEdit className="me-1" /> {t("edit")}
              </Button>
            </div>
            <hr
              className="mt-0 mb-4"
              style={{ backgroundColor: "#e0e0e0", opacity: 0.5 }}
            />

            <Row>
              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("first name")}</p>
                <p className="fw-medium mb-0">
                  {profileData?.name?.split(" ")[0]}
                </p>
              </Col>

              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("last name")}</p>
                <p className="fw-medium mb-0">
                  {profileData?.name?.split(" ")[1] || ""}
                </p>
              </Col>

              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("date of birth")}</p>
                <p className="fw-medium mb-0">
                  {formatDate(profileData?.dateOfBirth) || t("not specified")}
                </p>
              </Col>

              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("email address")}</p>
                <p className="fw-medium mb-0">{profileData?.email}</p>
              </Col>

              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("phone number")}</p>
                <p className="fw-medium mb-0">{profileData?.mobile}</p>
              </Col>

              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("user role")}</p>
                <Badge bg="primary" className="text-uppercase px-2 py-1">
                  {profileData?.role}
                </Badge>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Address */}
        <Card className="border-0 ">
          <Card.Body className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold mb-0">{t("address information")}</h5>
              <Button
                variant="light"
                className="d-flex align-items-center bg-primary text-white"
              >
                <FaEdit className="me-1" /> {t("edit")}
              </Button>
            </div>
            <hr
              className="mt-0 mb-4"
              style={{ backgroundColor: "#e0e0e0", opacity: 0.5 }}
            />

            <Row>
              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("country")}</p>
                <p className="fw-medium mb-0">{t("bangladesh")}</p>
              </Col>

              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("city")}</p>
                <p className="fw-medium mb-0">{profileData?.district}</p>
              </Col>

              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("area")}</p>
                <p className="fw-medium mb-0">{profileData?.thana}</p>
              </Col>

              <Col md={4} className="mb-3">
                <p className="fw-bold mb-1">{t("full address")}</p>
                <p className="fw-medium mb-0">{profileData?.address}</p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </Layout>
  );
};

export default ViewProfile;
